import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import FloorPrice from '../views/FloorPrice.vue'
import TotalVolume from '../views/TotalVolume.vue'
import CollectionDetails from '../views/CollectionDetails.vue'
import VerifyEmail from '../components/VerifyEmail.vue'
import SignIn from '../components/SignIn.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/floor-price',
    name: 'Floor Price',
    component: FloorPrice
  },
  {
    path: '/total-volume',
    name: 'Total Volume',
    component: TotalVolume
  },
  {
    path: '/collection/:id/:slug',
    name: 'CollectionDetails',
    component: CollectionDetails
  },
  {
    path: '/sign-in/verify-email',
    name: 'VerifyEmail',
    component: VerifyEmail
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
